'use strict';

/*
 * angular-google-directive v0.0.1
 * Adapted from angular-google-plus-directive
 * > ♡ CopyHeart 2013 by Jerad Bitner http://jeradbitner.com
 * > Copying is an act of love. Please copy.
 */

angular.module('directive.g-signin', []).directive('googleSignin', ['$window', function ($window) {
  var ending = /\.apps\.googleusercontent\.com$/;

  return {
    restrict: 'E',
    transclude: true,
    template: '<span></span>',
    replace: true,
    link: function (scope, element, attrs, ctrl, linker) {
      attrs.clientid += (ending.test(attrs.clientid) ? '' : '.apps.googleusercontent.com');

      attrs.$set('data-clientid', attrs.clientid);
      attrs.$set('theme', attrs.theme);

      // Some default values, based on prior versions of this directive
      var defaults = {
        onsuccess: 'onSignIn',
        onfailure: 'onSignInFailure',
        scope: 'profile email',
      };

      defaults.theme = attrs.theme;

      // Overwrite default values if explicitly set
      angular.forEach(Object.getOwnPropertyNames(defaults), function (propName) {
        if (attrs.hasOwnProperty(propName)) {
          defaults[propName] = attrs[propName];
        }
      });

      // Default language
      // Supported languages: https://developers.google.com/+/web/api/supported-languages
      attrs.$observe('language', function (value) {
        $window.___gcfg = {
          lang: value ? value : 'en'
        };
      });

      // Asynchronously load the Google Sign-in library.
      var po = document.createElement('script');
      po.type = 'text/javascript';
      po.async = true;
      po.src = 'https://apis.google.com/js/platform.js';
      var s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(po, s);

      linker(function (el, tScope) {
        po.onload = function () {
          if (el.length) {
            element.append(el);
          }
          gapi.load('auth2', () => {
            gapi.auth2
              .init({client_id: attrs.clientid})
              .then(() => {
                gapi.signin2.render(element[0], defaults);
              });
          });
        };
      });
    }
  }
}]).run(['$window', '$rootScope', function ($window, $rootScope) {
  $window.onSignIn = function (googleUser) {
    $rootScope.$broadcast('event:google-signin-success', googleUser.getAuthResponse());
  };
  $window.onSignInFailure = function () {
      $rootScope.$broadcast('event:google-signin-failure');
  };
}]);
